import {Injectable} from "@angular/core";
import {NgbDateParserFormatter, NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split('.');
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    const day: string = date ? (date.day < 10 ? `0${date.day}` : `${date.day}`) : '';
    const month: string = date ? (date.month < 10 ? `0${date.month}` : `${date.month}`) : '';
    return date ? `${day}.${month}.${date.year}` : '';
  }
}
